<template>
    <FormRequestIntegrations v-if="formType === FormRequestType.integrations"
                             :close-modal="closeOverlay"
                             :customer-no="customerNo"
                             :customer-name="customerName"/>
    <FormRequestItemExport v-else-if="formType === FormRequestType.itemExport" :close-modal="closeOverlay" :area-of-interests="areaOfInterests"/>
    <FormRequestPunchout v-else-if="formType === FormRequestType.punchout" :close-modal="closeOverlay"/>
    <FormRequestDropShipment v-else-if="formType === FormRequestType.dropshipment" :account="accountComputed" :close-modal="closeOverlay"/>
    <FormRequestDirectDebitOverlay v-else-if="formType === FormRequestType.directDebit" :account="accountComputed" :modal="modal"/>
</template>

<script setup lang="ts">
import { defineAsyncComponent, PropType, computed } from 'vue';
import { FormRequestType } from '@/project/modals/overlays/FormRequestOverlay.service';
import { IModal } from '@/core/modals/ModalState';
import { useModal } from '@/project/modals/useModal';
import { UserViewObject } from '@/types/apiServerContract';
import { BecomeACustomerInterestViewModel } from '@/types/contentServerContract';

const FormRequestDirectDebitOverlay = defineAsyncComponent(() => import('@/project/app/client-pages/my-account/forms/FormRequestDirectDebitOverlay.vue'));
const FormRequestDropShipment = defineAsyncComponent(() => import('@/project/app/client-pages/my-account/forms/FormRequestDropShipment.vue'));
const FormRequestIntegrations = defineAsyncComponent(() => import('@/project/app/client-pages/my-account/forms/FormRequestIntegrations.vue'));
const FormRequestPunchout = defineAsyncComponent(() => import('@/project/app/client-pages/my-account/forms/FormRequestPunchout.vue'));
const FormRequestItemExport = defineAsyncComponent(() => import('@/project/app/client-pages/my-account/forms/FormRequestItemExport.vue'));

const props = defineProps({
    modal: {
        type: Object as PropType<IModal>,
        required: true
    },
    formType: {
        type: Number as PropType<FormRequestType>,
        required: true
    },
    account: {
        type: Object as PropType<UserViewObject>,
        required: false,
        default: undefined
    },
    areaOfInterests: {
        type: Array as PropType<BecomeACustomerInterestViewModel[]>,
        required: false,
        default: undefined,
    },
    customerNo: {
        type: String,
        required: false,
        default: undefined
    },
    customerName: {
        type: String,
        required: false,
        default: undefined
    }
});

const { closeOverlay } = useModal(props.modal);

const accountComputed = computed(() => props.account as UserViewObject);

</script>
